// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__23tLI","filter":"styles_filter__2Oxaq"};